'use strict';

import angular from 'angular';

// import saRequestReference from './request_reference/request_reference_page/request_reference';
import saFbJoinModal from './request_reference/fb_join_modal/fb_join_modal';
import fbJoinModal from './request_reference/fb_join_modal/fb_join_modal.service';
import requestReferenceModal from './request_reference/request_reference_modal/request_reference_modal.service';
import saNoProfilePhotoModal from './no_profile_photo_modal/no_profile_photo_modal';
import noProfilePhotoModal from './no_profile_photo_modal/no_profile_photo_modal.service';
import saPayConversationModal from './pay_conversation_modal/pay_conversation_modal';
import payConversationModal from './pay_conversation_modal/pay_conversation_modal.service';
import saLocationConfirmationModal from './location_confirmation/location_confirmation_modal';
import locationConfirmationService from './location_confirmation/location_confirmation_service';
import saCreateTripBanner from './trips/create_trip_banner/create_trip_banner';
import saConversationTripAvatar from './conversations_trips/conversation_trip_avatar/conversation_trip_avatar';
import saConversationTrip from './conversations_trips/conversation_trip';

// System alerts
import saSystemAlerts from './system_alerts/system_alerts';
import systemAlerts from './system_alerts/system_alerts.service';

// trip offer accept modal
import saTripOfferAcceptModal from './conversations/trip_offer_accept_modal/trip_offer_accept_modal';
import tripOfferAcceptModal from './conversations/trip_offer_accept_modal/trip_offer_accept_modal.service';

import offerMessage from './trips/trips/send_offer_modal/offer_message.js';
import lastOfferMessage from './trips/trips/send_offer_modal/last_offer_message.js';
import sendOfferModal from './trips/trips/send_offer_modal/send_offer_modal.service.js';
import sendOfferSuccessAlert from './trips/common/send_offer_success_alert';

//  pay modal
// import saPayModal from './pay_modal/pay_modal';
import payModal from './pay_modal/pay_modal.service';
import creditCardType from './pay_modal/credit_card_type.service';

//  pay modal
import saFastPayModal from './fast_pay_modal/fast_pay_modal';
import fastPayModal from './fast_pay_modal/fast_pay_modal.service';

import saBraintreeModal from './braintree_modal/braintree_modal';
import braintreeModal from './braintree_modal/braintree_modal.service';

// modules
// import saMyTripsModule from './trips/my_trips';
// import saTripsModule from './trips/trips';

// translations
import 'nls!./trips/trips/trip_list/trip.json';
import 'nls!./trips/trips/trip_container/trip_container.json';
import 'nls!./trips/trips/send_offer_modal/send_offer_modal.json';

import 'nls!./trips/my_trips/create_trip_form/create_trip.json';
import 'nls!./trips/my_trips/my_trip_list/my_trip.json';

import 'nls!./conversations_trips/conversation_trip.json';
import 'nls!./conversations/trip_offer_accept_modal/trip_offer_accept_modal.json';
import 'nls!./pay_modal/pay_modal.json';
// import 'nls!./fast_pay_modal/fast_pay_modal.json';
import 'nls!./translations/guides.json';
import 'nls!./translations/dashboard.json';
import 'nls!./translations/leave_review.json';
import 'nls!./translations/recent_bookings.json';
import 'nls!./translations/intro.json';
import 'nls!./request_reference/request_reference_modal/request_reference_modal.json';


export default angular.module('components', [])

  .component('saNoProfilePhotoModal', saNoProfilePhotoModal)
  .factory('noProfilePhotoModal', noProfilePhotoModal)

  .component('saFbJoinModal', saFbJoinModal)
  .factory('fbJoinModal', fbJoinModal)

  .factory('requestReferenceModal', requestReferenceModal)

  .component('saTripOfferAcceptModal', saTripOfferAcceptModal)
  .factory('tripOfferAcceptModal', tripOfferAcceptModal)

  // .component('saPayModal', saPayModal)
  .factory('payModal', payModal)
  .factory('creditCardType', creditCardType)

  .factory('offerMessage', offerMessage)
  .factory('lastOfferMessage', lastOfferMessage)
  .factory('sendOfferModal', sendOfferModal)
  .factory('sendOfferSuccessAlert', sendOfferSuccessAlert)

  .component('saFastPayModal', saFastPayModal)
  .factory('fastPayModal', fastPayModal)

  .component('saBraintreeModal', saBraintreeModal)
  .factory('braintreeModal', braintreeModal)

  // System alerts
  .component('saSystemAlerts', saSystemAlerts)
  .factory('systemAlerts', systemAlerts)

  // .component('saRequestReference', saRequestReference)
  .component('saPayConversationModal', saPayConversationModal)
  .component('saCreateTripBanner', saCreateTripBanner)
  .component('saConversationTrip', saConversationTrip)
  .component('saConversationTripAvatar', saConversationTripAvatar)
  .component('saLocationConfirmationModal', saLocationConfirmationModal)
  .factory('locationConfirmationService', locationConfirmationService)
  .factory('payConversationModal', payConversationModal)
  .name;



// WEBPACK FOOTER //
// ./app/src/components/index.js